import { DictionaryItem } from "@app/shared/services/dictionary/dictionary-item.model";

export class Cities {
  private constructor(public readonly cities: DictionaryItem[]) {}

  static of(cities: DictionaryItem[]): Cities {
    return new Cities(cities);
  }

  findByName(city: string): DictionaryItem | null {
    const lowerCaseCity = city.toLowerCase();
    return this.cities.find(
      (c) => c.translation.toLowerCase() === lowerCaseCity
    );
  }

  find(city: DictionaryItem): DictionaryItem | null {
    return this.cities.find((c) => c.key === city.key);
  }

  firstIfSingle(): DictionaryItem {
    return this.cities.length === 1 ? this.cities[0] : null;
  }
}
